export const scrollToTop = (behavior: ScrollBehavior = 'instant') => {
    window.scrollTo({top: 0, left: 0, behavior: behavior});
};

/**
 * Parses a redirect path (e.g. "/clubs/abc/?show=join") into separate `to` and `search`
 * options for TanStack Router's navigate/Navigate, so that trailingSlash:'always' only
 * applies to the pathname and not to the query string.
 */
export const parseRedirectUrl = (redirect?: string): null | { to: string; search: () => Record<string, string> } => {
    if (!redirect || typeof window === 'undefined') {
        return null
    }
    const url = new URL(redirect, window.location.origin);
    const searchObj = Object.fromEntries(url.searchParams);
    return {to: url.pathname, search: () => searchObj};
};
